import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// --- IMPORTATION DES 5 PILIERS TECHNOLOGIQUES YARMOTEK ---
import LandingPage from './components/LandingPage';           // Vitrine & Recrutement
import SahelGuardOS from './components/SahelGuardOS';         // Cockpit Empereur (Moussa)
import PartnerPortal from './components/PartnerPortal';       // Enrôlement KYC & Wallet
import ClientSovereignView from './components/ClientSovereignView'; // Vigie Client & Riposte
import AgentCommandCenter from './components/AgentCommandCenter';   // Validation Upgrades & Commissions

/**
 * 🛰️ ARCHITECTURE SOUVERAINE SCELLÉE - VERSION FINALE DÉMO
 * ---------------------------------------------------
 * Architecture : Moussa Yarbanga | Yarmotek Sovereign Cloud
 * Update : Correction des endpoints API et routage automatique Cloudflare.
 * ---------------------------------------------------
 */

// CENTRALISATION DE L'API POUR TOUT L'EMPIRE (Version Cloudflare Active)
const SOUVEREIGN_API = "https://sahelguard-api.sahelguard.workers.dev";

const App = () => {
  const hostname = window.location.hostname;

  /**
   * 🔐 LOGIQUE DE ROUTAGE INTELLIGENTE
   * Redirige l'utilisateur vers son terminal spécifique après authentification.
   */
  const onLoginRedirect = (role) => {
    switch(role) {
      case 'admin': 
        window.location.href = "/empire-admin-gate"; 
        break;
      case 'reseller': 
        window.location.href = "/partner-terminal"; 
        break;
      case 'agent': 
        window.location.href = "/agent-command-center"; 
        break;
      case 'client': 
        window.location.href = "/my-protection"; 
        break;
      default: 
        window.location.href = "/";
    }
  };

  return (
    <Router>
      <Routes>
        
        {/* 🛡️ 1. VITRINE PUBLIQUE & RECRUTEMENT */}
        <Route 
          path="/" 
          element={
            // Si on est sur le sous-domaine admin, on bypass la landing pour la démo
            hostname.includes('sahelguard-admin') ? 
            <Navigate to="/empire-admin-gate" replace /> : 
            <LandingPage onLogin={onLoginRedirect} />
          } 
        />

        {/* 👑 2. COCKPIT EMPEREUR (Moussa Yarbanga - Super Admin) */}
        <Route 
          path="/empire-admin-gate" 
          element={<SahelGuardOS apiUrl={SOUVEREIGN_API} />} 
        />

        {/* 🏪 3. TERMINAL BOUTIQUE (Partenaires - Enrôlement) */}
        <Route 
          path="/partner-terminal" 
          element={
            <PartnerPortal 
              agentId="SG-AUTO-SYNC" 
              apiUrl={SOUVEREIGN_API} 
            />
          } 
        />

        {/* 💼 4. AGENT COMMAND CENTER (Gestionnaires d'Upgrades) */}
        <Route 
          path="/agent-command-center" 
          element={<AgentCommandCenter apiUrl={SOUVEREIGN_API} />} 
        />

        {/* 📱 5. LA VIGIE CLIENT (Utilisateurs finaux) */}
        <Route 
          path="/my-protection" 
          element={<ClientSovereignView apiUrl={SOUVEREIGN_API} />} 
        />

        {/* 🔐 SÉCURITÉ : Redirection automatique */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
};

export default App;